// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"45a29de4","453":"0b94753b","698":"755e0c26","821":"8895aefd"}[chunkId] + ".chunk.js";
};